export const ID_DOCUMENT_SCAN_LIMIT = 2;

export const INTERNAL_SCENARIO_TYPES = {
  MRZ_AND_LOCATE: "MrzAndLocate",
  MRZ_OR_LOCATE: "MrzOrLocate",
  MRZ: "Mrz",
  LOCATE: "Locate",
};
